/**
 * Ryan O'Dowd
 * 2026-07-12
 * © Copyright 2026 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import Animated, {
  interpolate,
  useAnimatedStyle,
} from 'react-native-reanimated';
import React from 'react';
import getStyles from './styles';
import hooks from '@hooks';

const SwipeableAction = (props: SwipeableActionProps) => {
  const styles = hooks.useStyles(getStyles);

  const animatedStyle = useAnimatedStyle(() => ({
    opacity: interpolate(
      props.progress.value - 0.2, // wait until progress has started meaningfully before showing anything // @TODO: this should probably be by translate amount, not progress (maybe not though because it just has to be enough to not interfere with opacity if a press is triggered before the swipe)
      [0, 0.01, 1],
      [0, 1, 1],
    ),
  }));

  return (
    <Animated.View style={[styles.container, animatedStyle]}>
      {props.children}
    </Animated.View>
  );
};

class SwipeableActionProps {
  children: any;
  progress: any; // @TODO: sharedvalue
};

export default SwipeableAction;
